import React, { useState, useContext } from "react";
import "./style.css";
import { Send } from "lucide-react";
import Button from "@mui/material/Button";
import { postData } from "../../utils/api"; 
import { MyContext } from "../../App";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const context = useContext(MyContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Please enter a valid email address"
      });
      return;
    }

    setLoading(true);

    try {
      const response = await postData("/api/newsletter/subscribe", {
        email: email.trim().toLowerCase(),
      });

      if (response.success) {
        context.setAlertBox({
          open: true,
          error: false,
          msg: response.message || "Successfully subscribed! Welcome to our newsletter."
        });
        setEmail(""); 
      } else {
        context.setAlertBox({
          open: true,
          error: true,
          msg: response.message || "Subscription failed. Please try again."
        });
      }
    } catch (error) {
      console.error("Newsletter subscription error:", error);

      let errorMsg = "Failed to subscribe. Please try again later.";
      if (error.response?.status === 409) {
        errorMsg = "Email is already subscribed to our newsletter";
      } else if (error.response?.data?.message) {
        errorMsg = error.response.data.message;
      }

      context.setAlertBox({
        open: true,
        error: true,
        msg: errorMsg
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <>
      <div className="newLetterBanner">
        <form onSubmit={handleSubmit} className="inputWrapper">
          <Send className="sendIcon" />
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={handleInputChange}
            disabled={loading}
          />
          <Button
            type="submit"
            className={`bg-g subscribeBtn ${loading ? "loading" : ""}`}
            disabled={loading || !email.trim()}
          >
            {loading ? "Subscribing..." : "Subscribe"}
          </Button>
        </form>
      </div>
    </>
  );
};

export default NewsletterForm;
